import React from 'react';
import Spinner from '../Spinner';

interface ButtonProps {
  text?: string;
  icon?: React.ReactNode;
  type?: 'button' | 'submit';
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: (_: any) => void;
}

const Button: React.FC<ButtonProps> = ({
  text,
  icon,
  type = 'button',
  className,
  disabled,
  loading,
  onClick,
}) => {
  return (
    <button
      className={`btn ${className || 'btn-primary'}`}
      disabled={disabled || loading}
      type={type}
      onClick={onClick}
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          {icon && icon}
          {text && text}
        </>
      )}
    </button>
  );
};

export default Button;
